import Box from "@material-ui/core/Box";
import { styled, Theme } from "@material-ui/core";

export default styled(Box)<Theme>(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: "36px",
  lineHeight: "120%",
}));
